import './style.less';

export default class ExternalModalCtrl {
    constructor(close, link, $sce) {
        this.close = close;
        this.link = $sce.trustAsResourceUrl(link);
    }

    close () {
        this.close();
    }

}


// WEBPACK FOOTER //
// ./src/app/modals/external/ctrl.js